import * as React from 'react';
import {SelectionDropDownAdvanced} from 'damco-components';
import { findObjById } from 'utilities/util';
import styled from 'styled-components';
import { SLabel } from 'views/customer-billing/issueInvoices/details/constants';
import { SErrorMessage } from 'components/input';

const SEmpty = styled.label`
    display: block;
    font-size: 0.8rem;
    margin-bottom: .5rem
`;
interface IDataList{
    id: string,
    data: any[] | selectBoxOptions[];
    label: string;
    value?: string | number;
    disabled?: boolean;
    error?: any;
    hasError: boolean;
    pattern?: string;
    className?:string;
    onChange: (e:any) => void;
    isDisabled?:boolean
}
interface selectBoxOptions{
    value: string | number,
    label: string
}
interface IState{
    isInValid: boolean
}
export class DataList extends React.Component<IDataList, IState> {
    public state = {
        isInValid: false,
    }
    constructor(props:IDataList){
        super(props);
        this.state.isInValid = this.props.hasError? this.props.hasError : false;
    }
    public onChange = (value:any) => {
        if(value){
            this.props.onChange(value[0])
        }
    }
    public getClass = () => {
        const hasError:string =  this.props.hasError ? 'selectionDropDownAdvanced error' : 'selectionDropDownAdvanced';
        const classNameDefault:string = this.props.className?this.props.className:'col-30';
        return `${classNameDefault} ${hasError}`;
    }
    public render(){
        const setDropDownValue = () =>{
            if(this.props.value && this.props.data){
                const objList = findObjById(this.props.value, this.props.data, 'value');
                if(objList){
                    return objList
                }
            }
            return ''
        }
        if (this.props.data && this.props.data.length>0) {
            return (
                <div className={this.getClass()} id={`dropDown-${this.props.id}`}>
                    <SelectionDropDownAdvanced 
                        options={this.props.data} 
                        isDisabled={this.props.isDisabled}
                        isSearchable={true} 
                        isMulti={false} 
                        onChange={this.onChange}
                        label={this.props.label}
                        isClearable={false}
                        defaultValue={setDropDownValue()}
                        />
                        <SLabel>{this.props.error && this.props.hasError && <SErrorMessage>{this.props.error}</SErrorMessage>}</SLabel>
                </div>
            );
        } else {
            return (
                <div className={this.getClass()} id={`dropDown-${this.props.id}`}>
                    <SEmpty>{this.props.label}</SEmpty>
                    <label>No data</label>
                </div>
            )
        }
    }
}